import {Component, OnInit, Inject, HostListener, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'irb-process-scheduled-dialog',
  templateUrl: './process-scheduled-dialog.component.html',
  styleUrls: ['./process-scheduled-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ProcessScheduledDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ProcessScheduledDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any) {

  }
  ngOnInit(): void {

  }
  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    const ESCAPE_KEYCODE = 27;
    const ENTER_KEYCODE = 13;
    if (event.key === 'Escape' || event.keyCode === ESCAPE_KEYCODE
        || event.key === 'Enter' || event.keyCode === ENTER_KEYCODE) {
      this.dialogRef.close();
    }
  }
}
